import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Input } from 'semantic-ui-react';

import CommonErrorIcon
  from 'components/common/CommonErrorIcon';
import CommonMessage from 'components/common/CommonMessage';

import './CommonTextInput.css';

const ENTER_KEY = 13;

class CommonTextInput extends Component {
  static propTypes = {
    executedFunction: PropTypes.func.isRequired,
    initValue: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    validationErrors: PropTypes.arrayOf(PropTypes.string),
    actionErrors: PropTypes.object,
    url: PropTypes.bool,
  };

  static defaultProps = {
    initValue: null,
    placeholder: null,
    validationErrors: null,
    actionErrors: null,
    url: null,
  };

  state = {
    initialValue: '',
    currentValue: '',
    validationErrors: [],
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);
    if (this.props.initValue) {
      this.setState({
        initialValue: this.props.initValue,
        currentValue: this.props.initValue,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentValue !== this.state.currentValue) {
      this.setState({ validationErrors: [] });
    }

    if (prevProps.initValue !== this.props.initValue) {
      this.setState({ currentValue: this.props.initValue });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  executeValidation = () => {
    const errors = this.props.validationErrors(this.state.currentValue) || null;
    if (errors && errors.length > 0) {
      this.setState({ validationErrors: errors });
    }
  };

  executeAction = () => {
    const { currentValue, initialValue } = this.state;
    if (currentValue !== initialValue) {
      this.executeValidation();
    }

    if (
      currentValue !== initialValue &&
      this.state.validationErrors &&
      this.state.validationErrors.length === 0
    ) {
      this.setState({ initialValue: this.state.currentValue.trim() });
      this.props.executedFunction(currentValue);
    }
  };

  onEnterClick = event => {
    if (event.keyCode === ENTER_KEY) {
      this.executeAction();
    }
  };

  render() {
    const { actionErrors, label, placeholder, url } = this.props;
    const { validationErrors, currentValue } = this.state;
    const isValidationErrors = validationErrors && validationErrors.length > 0;

    return (
      <div className={`common-text-input__component
        ${isValidationErrors ? ' error' : ''}`}>
        <div className="input-wrapper">
          <Input
            className={url ? ' url' : ''}
            value={currentValue}
            placeholder={placeholder}
            onChange={(e) => {
              e.preventDefault();
              this.setState({ currentValue: e.target.value });
            }}
            onBlur={() => { this.executeAction(); }}
          />

          {isValidationErrors &&
            <CommonErrorIcon
              errorText={validationErrors.map(error => (
                <div>{error}</div>
              ))}
            />
          }
        </div>

        <div className="divider" />
        <div className="label">{label}</div>

        {actionErrors &&
          <CommonMessage
            error
            errors={actionErrors}
          />
        }

      </div>
    );
  }
}

export default CommonTextInput;
